/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Select_Guide_PromptInputs */

const en_style_guide_select_guide_prompt = /** @type {(inputs: Style_Guide_Select_Guide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a style guide from the list above to begin.`)
};

const fr_style_guide_select_guide_prompt = /** @type {(inputs: Style_Guide_Select_Guide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionnez un guide de style dans la liste ci-dessus pour commencer.`)
};

const de_style_guide_select_guide_prompt = /** @type {(inputs: Style_Guide_Select_Guide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie einen Styleguide aus der obigen Liste aus, um zu beginnen.`)
};

const it_style_guide_select_guide_prompt = /** @type {(inputs: Style_Guide_Select_Guide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per iniziare, seleziona una guida di stile dall'elenco sopra.`)
};

const ru_style_guide_select_guide_prompt = /** @type {(inputs: Style_Guide_Select_Guide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите стиль оформления из списка выше, чтобы начать.`)
};

const es_style_guide_select_guide_prompt = /** @type {(inputs: Style_Guide_Select_Guide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione una guía de estilo de la lista anterior para comenzar.`)
};

const zh_cn2_style_guide_select_guide_prompt = /** @type {(inputs: Style_Guide_Select_Guide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从上面的列表中选择一个风格指南开始。`)
};

const ja_style_guide_select_guide_prompt = /** @type {(inputs: Style_Guide_Select_Guide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始するには、上のリストからスタイル ガイドを選択してください。`)
};

const hi_style_guide_select_guide_prompt = /** @type {(inputs: Style_Guide_Select_Guide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शुरुआत करने के लिए ऊपर दी गई सूची से एक स्टाइल गाइड चुनें।`)
};

const pt_pt2_style_guide_select_guide_prompt = /** @type {(inputs: Style_Guide_Select_Guide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione um guia de estilo da lista acima para começar.`)
};

/**
* | output |
* | --- |
* | "Select a style guide from the list above to begin." |
*
* @param {Style_Guide_Select_Guide_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_select_guide_prompt = /** @type {((inputs?: Style_Guide_Select_Guide_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Select_Guide_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_select_guide_prompt(inputs)
	if (locale === "de") return de_style_guide_select_guide_prompt(inputs)
	if (locale === "it") return it_style_guide_select_guide_prompt(inputs)
	if (locale === "ru") return ru_style_guide_select_guide_prompt(inputs)
	if (locale === "es") return es_style_guide_select_guide_prompt(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_select_guide_prompt(inputs)
	if (locale === "ja") return ja_style_guide_select_guide_prompt(inputs)
	if (locale === "hi") return hi_style_guide_select_guide_prompt(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_select_guide_prompt(inputs)
	return en_style_guide_select_guide_prompt(inputs)
});